import React from 'react';
import styles from './Footer.module.scss';

export default function Footer(props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles['container-fluid']}>
        <footer>
          <div>
            &copy; {new Date().getFullYear()} Cymbio | <a href="mailto:info@cym.bio">Support</a>
          </div>
          <div>
            +1-646-783-1577 |{' '}
            <a href="mailto:info@cym.bio" target="_blank" rel="noreferrer">
              info@cym.bio
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
